import React, {useEffect} from 'react';
import PresetDetails from "../components/preset-details";
import PresetTags from "../components/preset-tags";
import PresetPlugins from "../components/preset-plugins";
import MorePresets from "../components/more-presets";
import {getListItemByPresetPlugin, sendProductImpressionAnalytics} from "../services/logic-helper";
import {useAppSelector} from "../../creator-presets/DAL/store";
import {PresetPluginDM} from "../interfaces";
import {PresetDM, PresetTagDM} from "../../common/interfaces";

/**
 * the entry point
 */
const App: React.FC = () => {
    const PresetPageData = useAppSelector((store) => store.PresetPageData);
    const imgCdnDomain = useAppSelector((store) => store.imgCdnDomain);
    const mainPreset = useAppSelector((store) => store.mainPreset);
    const mainPresetTags = (PresetPageData.presetTags as PresetTagDM[]).filter(presetTag => mainPreset.presetID === presetTag.presetID);
    const otherPresets = (PresetPageData.presets as PresetDM[]).filter(preset => preset.presetID !== mainPreset.presetID);

    useEffect(() => {
        //on load: add products impression
        let list = (PresetPageData.presetsPlugins as PresetPluginDM[]).map((item) =>  getListItemByPresetPlugin(item,imgCdnDomain));
        sendProductImpressionAnalytics(list,"Preset Plugins");

    }, [PresetPageData.presetsPlugins,imgCdnDomain]);
    return (
        <div className="waves-box-ml mx-auto text-left px-5 md:px-12 xl:px-0 mt-8">
            <PresetDetails />
            {mainPresetTags.length > 0 && <PresetTags /> }
            {PresetPageData.presetsPlugins.length > 0 && <PresetPlugins /> }
            {otherPresets.length > 0 &&  <MorePresets />}
        </div>

    );
};

export default App;

